import { render, staticRenderFns } from "./Dataservices.vue?vue&type=template&id=18a72f59&scoped=true&web=true&"
import script from "./Dataservices.vue?vue&type=script&lang=ts&"
export * from "./Dataservices.vue?vue&type=script&lang=ts&"
import style0 from "./Dataservices.vue?vue&type=style&index=0&id=18a72f59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a72f59",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
